/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_onboarding_account_type_business_description = /** @type {(inputs: {}) => string} */ () => {
	return `Para empresas, fintechs y marketplaces que construyen productos financieros.`
};

const en_onboarding_account_type_business_description = /** @type {(inputs: {}) => string} */ () => {
	return `For companies, fintechs, and marketplaces building financial products.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const onboarding_account_type_business_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.onboarding_account_type_business_description(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("onboarding_account_type_business_description", locale)
	if (locale === "es") return es_onboarding_account_type_business_description(inputs)
	return en_onboarding_account_type_business_description(inputs)
};
export { onboarding_account_type_business_description as "onboarding.account_type.business_description" }